var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.author.profile_updated && _vm.author.phone_verified
    ? _c(
        "a",
        {
          staticClass: "text-danger",
          attrs: {
            href: _vm.$root.url("orn_web_user_view", {
              username: _vm.author.username,
            }),
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.author.display_name) + "\n")]
      )
    : _c("span", [_vm._v(_vm._s(_vm.author.display_name))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }